import FormattedReactMessage from 'I18n/components/FormattedReactMessage';
import FormattedMessage from 'I18n/components/FormattedMessage';
import usePaymentPanel from 'FormsUI/components/hooks/payment/usePaymentPanel';
import { Link } from 'foundations-components/transitional/components/Link';
import { jsx as _jsx } from "react/jsx-runtime";
const PaymentsSection = () => {
  const {
    handlePaymentSelect
  } = usePaymentPanel();
  return /*#__PURE__*/_jsx("p", {
    children: /*#__PURE__*/_jsx(FormattedReactMessage, {
      message: `editor.form.config.changePaymentsLink`,
      options: {
        options: /*#__PURE__*/_jsx(Link, {
          "data-test-id": "form-row__name-link",
          onClick: handlePaymentSelect,
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: `editor.form.config.paymentField`
          })
        })
      }
    })
  });
};
export default PaymentsSection;